"use client";
import { useEffect } from "react";

const ScrollToTopOnMount = ({ smooth = false }) => {
  useEffect(() => {
    const scrollProps = {
      top: 0,
      left: 0,
    };
    if (smooth) scrollProps.behavior = "smooth";
    window.scrollTo(scrollProps);
  }, []);

  return null;
};

export default ScrollToTopOnMount;
